module.exports = __webpack_public_path__ + "img/search.c51674de.svg";